const BoardConfig = {
    name            : 'Board',
    menuName        : 'Board',
    icon            : 'i5-board',
    image           : 'board',
    iconSvg         : 'isvg-view-board',
    url             : 'board',
    stringId        : 'board',
    description     : 'Advanced Kanban board with multiple grouping options and project hierarchy support.',
    customViewName  : 'Board',
    inheritance     : true,
    hasTemplates    : true,
    canBeInProject  : true,
}

export const PROJECT_BOARD_CONFIG = {
    ...BoardConfig,
    // key2: "newValue2",  // Replacing the value for key2
}



